module.exports = __webpack_public_path__ + "static/cadmodel-da9a14549557c1e5fcc0b6ea6a188fc5.png";